import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { setFullViewportWidthStyles, theme } from "shared/lib/styles";

import { AdSlot } from "scmp-app/components/advertisement/ad-slots/ad-slot";
import { GameType } from "scmp-app/components/games/types";

type ThemeProps = {
  $theme?: GameType;
};

export const PageContainer = styled.div<ThemeProps>`
  ${setFullViewportWidthStyles}
  background-color: #ffffff;

  ${props =>
    props.$theme === GameType.Cryptic &&
    css`
      background-color: #1e2836;
    `}
`;

export const StyledAdSlot = styled(AdSlot)``;

export const AdsContainer = styled.div<ThemeProps>`
  ${theme.breakpoints.up("tablet")} {
    padding-block: 32px;
    padding-inline: 0;
  }

  ${theme.breakpoints.up("desktop")} {
    padding-block: 40px;
    padding-inline: 0;
  }

  ${StyledAdSlot} {
    background-color: #f6f6f6;
  }

  ${props =>
    props.$theme === GameType.Cryptic &&
    css`
      background-color: #1e2836;

      ${StyledAdSlot} {
        background-color: #222222;
      }
    `}
`;
